<template>
  <div class="sheji" style="padding-top: 50px;">
    <img src="../../static/image/sysj.png" class="fullWidth" />
    <div class="design">
      <div class="design_left">
        <h3 class="design_title">商业模式设计</h3>
        <p
          class="design_content"
        >商业模式设计，是在对商业环境、市场需求、技术趋势等充分把握的基础上，精确定位目标客户，设计业务系统，构建关键能力，进行盈利结构、现金流结构设计，并通过验证、推广、规模化三个阶段，形成企业价值的过程。</p>
        <p class="design_content">
          商业模式是一个企业满足消费者需求的系统，这个系统组织管理企业的各种资源（资金、原材料、人力资源、作业方式、销售方式、信息、品牌和知识产权、企业所处的环境、创新力，又称输入变量），形成能够提供消费者无法自力而必须购买的产品和服务（输出变量），因而具有自己能复制且别人不能复制，或者自己在复制中占据市场优势地位的特性。
          任何一个商业模式都是一个由客户价值、企业资源和能力、盈利方式构成的三维立体模式。任何一个成功的商业模式都具有能提供独特的价值、难以模仿与复制、落地可执行的特征。
        </p>
      </div>
      <div class="design_right">
        <img src="../../static/image/a0dd0e5e3f48126a62075bab56d64cee.png" alt />
      </div>
    </div>
    <div class="equityStructure">
      <h2 class="equityStructure_title">股权架构</h2>
      <p class="subtitle">
        通过“企业价值定位+顶层架构设计+实施路径规划+常年顾问辅导”，
        为中小企业量身定制股权架构设计，一站式股权激励落地指导，助力中小企业跨越式发展
      </p>
      <ul class="equityStructure_list">
        <li>
          <div>
            <img src="../../static/image/subtitle1.png" alt style="width:48px;height:48px" />
          </div>
          <div>完善公司治理</div>
        </li>
        <li>
          <div>
            <img src="../../static/image/subtitle2.png" alt style="width:48px;height:48px" />
          </div>
          <div>科学分配股权</div>
        </li>
        <li>
          <div>
            <img src="../../static/image/subtitle3.png" alt style="width:48px;height:48px" />
          </div>
          <div>提升公司价值</div>
        </li>
      </ul>
      <ul class="equityStructure_list">
        <li>
          <div>
            <img src="../../static/image/subtitle4.png" alt style="width:48px;height:48px" />
          </div>
          <div>
            奖励功臣元老
            激励骨干员工
          </div>
        </li>
        <li>
          <div>
            <img src="../../static/image/subtitle5.png" alt style="width:48px;height:48px" />
          </div>
          <div>
            助力企业成长
            提升经营管理效率
          </div>
        </li>
        <li>
          <div>
            <img src="../../static/image/subtitle6.png" alt style="width:48px;height:48px" />
          </div>
          <div>
            目标一致、行动一致
            高度归属感
          </div>
        </li>
      </ul>
    </div>
    <div class="Platform_design">
      <div class="Platform_design_left">
        <div class="Platform_design_left1">
          <img src="../../static/image/Platform_design1.png" alt />
        </div>
        <div class="Platform_design_left2">
          <img src="../../static/image/Platform_design2.png" alt />
        </div>
      </div>
      <div class="Platform_design_right">
        <h2 class="Platform_design_right_title">平台设计</h2>
        <p>平台定位是指企业通过其产品及其品牌，基于顾客需求，将其企业独特的个性、文化和良好形象，塑造于消费者心目中，并占据一定位置。包含五大方面：</p>
        <ul>
          <li>1.平台价值定位</li>
          <li>2.平台商业模式创新设计</li>
          <li>3.平台核心竞争力构建</li>
          <li>4.平台运营体系设计</li>
          <li>5.平台核心业务流程设计</li>
        </ul>
      </div>
    </div>
    <div class="Brand—design">
      <h2 class="Brand—design_title">品牌全案设计</h2>
      <p
        class="Brand—design_content"
      >品牌全案设计，不是简单的策划+设计，以品牌创意策略的核心逻辑贯穿全案，结合企业的实际市场应用进行顶层设计，涵盖品牌创立与升级过程中的一切前期创意策略和后期落地执行。</p>
      <ul class="Brand—design_list">
        <li
          v-for="(item,i) in menu_list"
          :key="i"
          :class="[i===suoyin?'active':'']"
          @mouseover="hover(item,i)"
          @mouseout="leave(i,item)"
        >
          <div>
            <img :src="item.icon" alt />
          </div>
          <div>{{item.wz}}</div>
        </li>
      </ul>
    </div>
    <div class="Brand_principle">
      <h2 class="Brand_principle_title">品牌全案设计的三个原则</h2>
      <p class="Brand_principle_content">创意虽重要，原则价更高，多年来我们一直坚守，不改初衷</p>
      <ul class="Brand_principle_list">
        <li>
          <div class="Brand_principle1">能落地，不做假大空</div>
          <div class="Brand_principle2"></div>
          <div class="Brand_principle3">
            一切品牌策略和创意以落地为最终目标，不
            落地的设计坚决不做。
          </div>
        </li>
        <li>
          <div class="Brand_principle1">高效率，不拖延项目</div>
          <div class="Brand_principle2"></div>
          <div class="Brand_principle3">
            一切以客户为先，不错过客户的最佳执行时机
            按期完成全案设计。
          </div>
        </li>
        <li>
          <div class="Brand_principle1">讲平衡，不脱离应用</div>
          <div class="Brand_principle2"></div>
          <div class="Brand_principle3">
            创意设计兼顾实用与执行，最大程度发挥
            创意对市场营销的推动。
          </div>
        </li>
      </ul>
    </div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
var img_url_i = "";
export default {
  name: "sheji",
  data() {
    return {
      menu_list: [
        { icon: "../../static/image/sysj1.png", wz: "洞察" },
        { icon: "../../static/image/sysj2.png", wz: "策略" },
        { icon: "../../static/image/sysj3.png", wz: "设计" },
        { icon: "../../static/image/sysj4.png", wz: "激活" }
      ],
      suoyin: ""
    };
  },
  methods: {
    hover(item, index) {
      this.suoyin = index;
      if (this.suoyin == index) {
        this.menu_list.forEach(itemc => {
          if (item == itemc) {
            itemc.icon = "../../static/image/sysj1" + (index + 1) + ".png";
          }
        });
      }
    },
    leave(index, item) {
      this.suoyin = index;
      if (this.suoyin == index) {
        this.menu_list.forEach(itemc => {
          if (item == itemc) {
            itemc.icon = "../../static/image/sysj" + (index + 1) + ".png";
          }
        });
      }
      this.suoyin = "";
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.design {
  width: 1200px;
  margin: 116px auto;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
}
.design_left {
  width: 577px;
  padding: 20px 0 0 20px;
  box-sizing: border-box;
}
.design_left .design_title {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.design_left .design_content {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #333333;
  line-height: 24px;
  margin: 30px 0 20px 0;
}
.design_right {
  width: 556px;
  position: relative;
}
.design_right img {
  width: 100%;
  position: absolute;
  top: -145px;
  left: 0;
}
.equityStructure {
  width: 1200px;
  margin: 0 auto;
}
.equityStructure_title {
  text-align: center;
  color: #333;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.subtitle {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
  text-align: center;
  margin-top: 10px;
}
.equityStructure_list {
  width: 1200px;
  list-style: none;
  margin-top: 79px;
  display: flex;
  justify-content: space-between;
}
.equityStructure_list li {
  width: 212px;
  display: flex;
  align-items: center;
}
.equityStructure_list li div {
  margin: 0 6px;
}
.Platform_design {
  background: url("../../static/image/Platform_design.png") no-repeat top center;
  background-size: 100% 100%;
  height: 400px;
  margin-top: 207px;
  display: flex;
}
.Platform_design_left {
  flex: 50%;
  position: relative;
}
.Platform_design_right {
  flex: 50%;
  padding: 50px;
  box-sizing: border-box;
}
.Platform_design_left1 {
  width: 552px;
  height: 360px;
  position: absolute;
  right: 88px;
  top: -55px;
}
.Platform_design_left1 img {
  width: 100%;
  height: 100%;
}
.Platform_design_left2 {
  width: 200px;
  height: 240px;
  position: absolute;
  right: 0px;
  bottom: 30px;
}
.Platform_design_left2 img {
  width: 100%;
  height: 100%;
}
.Platform_design_right_title {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
}
.Platform_design_right p {
  width: 477px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  margin-top: 32px;
}
.Platform_design_right ul {
  list-style: none;
  margin-top: 32px;
}
.Platform_design_right ul li {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
}
.Brand—design {
  width: 1200px;
  margin: 50px auto;
  height: 500px;
}
.Brand—design_title {
  text-align: center;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.Brand—design_content {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.Brand—design_list {
  list-style: none;
  display: flex;
  justify-content: space-between;
  margin-top: 90px;
}
.Brand—design_list > li {
  list-style: none;
  width: 280px;
  height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 5px 0px rgba(7, 0, 2, 0.15);
  border-radius: 10px;
}
.Brand—design_list > li div:nth-child(1) {
  margin: 50px 0 26px 0;
}
.Brand—design_list > li div {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  display: flex;
  align-items: center;
}
.Brand—design_list > li.active {
  color: #fff;
  background: #ff8932;
}
.Brand—design_list > li.active div {
  color: #fff;
}
.Brand_principle {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0px;
}
.Brand_principle_title {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
.Brand_principle_content {
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  margin: 30px 0;
}
.Brand_principle_list {
  list-style: none;
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}
.Brand_principle_list li {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 266px;
}
.Brand_principle_list li div {
  margin: 10px 0;
}
.Brand_principle_list li div.Brand_principle2 {
  width: 80px;
  height: 3px;
  background: #ff8932;
}
.Brand_principle_list li div.Brand_principle1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 137, 50, 1);
}
.Brand_principle_list li div.Brand_principle3 {
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/sysj.vue